module.exports = __webpack_public_path__ + "media/images/underline-gold-6b1ecad4a368923ef90c38c5b14744aa.svg";